import { z } from 'zod';
import { UserSchema } from '../../entities/user/user.schema';
import { IncludeDeletedRequestSchema } from '../../shared/include-deleted.schema';
/**
 * Show Org Member Request Schema
 * GET /api/v2/org-members/:id
 */ export const ShowOrgMemberRequestSchema = IncludeDeletedRequestSchema;
/**
 * Show Org Member Response Schema
 * GET /api/v2/org-members/:id
 */ export const ShowOrgMemberResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=show-org-member.schema.js.map